<template>
  <Card>
    <Button type="primary" class="public-fr" icon="ios-undo" @click="back"
      >返回</Button
    >
    <table style="margin-top: 40px">
      <tr>
        <th colspan="7">申补记录信息</th>
      </tr>
      <tr>
        <th>申诉人</th>
        <td>{{ detail.srName }}</td>
        <th>申诉人编号</th>
        <td>{{ detail.srId }}</td>
        <th>二维码编码</th>
        <td>{{ detail.qrCode }}</td>
      </tr>
      <tr>
        <th>二维码基础码</th>
        <td>{{ detail.qrBaseCode }}</td>
        <th>物料名称</th>
        <td>{{ detail.name }}</td>
        <th>渠道编码</th>
        <td>{{ detail.channelCode }}</td>
      </tr>
      <tr>
        <th>品牌编号</th>
        <td>{{ detail.brandCode }}</td>
        <th>批次号</th>
        <td>{{ detail.batchNumber }}</td>
        <th>申诉类型</th>
        <td>{{ detail.appealType==1?'码破损':detail.appealType==2?'码丢失':'物料丢失' }}</td>
      </tr>
      <tr>
        <th>申诉时间</th>
        <td>{{ detail.appealTime }}</td>
        <th>申诉原因</th>
        <td>{{ detail.appealReason }}</td>
        <th></th>
        <td></td>
      </tr>
    </table>
  </Card>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      let data = this.$route.query;
      this.$api.frmLossDetail(data).then((res) => {
        if (res.code == "200") {
          this.detail = res.data;
        }
      });
    },
    back() {
      this.$router.push({
        path: "frmLossList",
      });
    },
  },
};
</script>
<style scoped>
table {
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
}

th,
td {
  padding: 0 10px;
  text-align: center;
  border: 1px solid #dcdee2;
  line-height: 30px;
  color: #515a6e;
  font-size: 12px;
}

th {
  background: #f8f8f9;
}
</style>





// WEBPACK FOOTER //
// src/views/material/frmLossDetail.vue